import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/orders/{{orderNumber}}'

export default {
  /**
   * @description Get a retailer's order by order number
   * @function getRetailerOrder
   * @param {String} retailerId
   * @param {String} orderNumber - the customer facing order number
   * @param {Object} params
   * @param {Number} [params.latitude]
   * @param {Number} [params.longitude]
   * @param {Boolean} [params.raw=false] - true to get full response
   * @returns {Promise}
   */
  getSingle(retailerId, orderNumber, { latitude = null, longitude = null, raw = false }) {
    let params = {}
    if (latitude) params.latitude = latitude
    if (longitude) params.longitude = longitude

    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId, orderNumber }), {
      raw,
      params: { ...params },
    })
  },

  /**
   * @description Submit a return request
   * @function submitReturn
   * @param {String} retailerId
   * @param {String} orderNumber - the customer facing order number
   * @param {Object} body
   * @returns {Promise}
   */
  submitReturn(retailerId, orderNumber, body) {
    return $fetch.peg(`${replacePathTokens(ENDPOINT, { retailerId, orderNumber })}/return`, {
      method: 'POST',
      body,
    })
  },

  /**
   * @description Lookup package dimensions for a fulfillment using AI
   * @function packageDimensionLookup
   * @param {String} retailerId
   * @param {String} orderNumber - the customer facing order number
   * @param {String} fulfillmentId - the fulfillment ID to lookup dimensions for
   * @returns {Promise}
   */
  packageDimensionLookup(retailerId, orderNumber, fulfillmentId) {
    return $fetch.peg(`${replacePathTokens(ENDPOINT, { retailerId, orderNumber })}/packageDimensionLookup`, {
      method: 'POST',
      body: { fulfillmentId },
    })
  },
}
